import { render } from "./EuSustainability.vue?vue&type=template&id=0c7b7fac&scoped=true"
import script from "./EuSustainability.vue?vue&type=script&lang=js"
export * from "./EuSustainability.vue?vue&type=script&lang=js"

import "./EuSustainability.vue?vue&type=style&index=0&id=0c7b7fac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7b7fac"]])

export default __exports__